import AgencyHelper from 'features/Agency/agencyHelper';
import { ChargeConstants } from 'features/Charge/chargeHelper';
import { AppDialogHelper } from 'general/components/AppDialog';
import KTFormInput, {
  KTFormInputType,
} from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import KTBSDropdown from 'general/components/OtherKeenComponents/KTBSDropdown';
import AppColors from 'general/constants/AppColors';
import AppResource from 'general/constants/AppResource';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import _ from 'lodash';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

AgencyWithdrawView.propTypes = {};

function AgencyWithdrawView(props) {
  // MARK: ---- PROPERTIES ----
  const { user } = useSelector((state) => state.auth);
  const [balance, setBalance] = useState(0);
  const isAgency = user?.role === ChargeConstants.UserRole.AGENCY;
  const [readyToValidate, setReadyToValidate] = useState(false);
  const [amount, setAmount] = useState('');
  const [loading, setLoading] = useState(false);
  const [selectedBankAccount, setSelectedBankAccount] = useState(null);
  const [bankAccountList, setBankAccountList] = useState([]);
  useEffect(() => {
    if (isAgency) {
      const agencyId = user?.agencyId;
      AgencyHelper.API.requestGetAgencyBankAccountList(agencyId).then((response) => {
        setBankAccountList(response.bankAccounts);
      });
    }
    setBalance(user?.agency?.balance ?? 0);
  }, [user, isAgency]);
  const bankAccountOptions = useMemo(() => {
    return bankAccountList.map((item) => ({
      name: item.bankAccount,
      value: item.bankAccountId,
    }));
  }, [bankAccountList]);
  useEffect(() => {
    const defaultBankAccount = _.find(bankAccountList, (item) => item.defaultAccount === 1);
    if (Utils.isValid(defaultBankAccount)) {
      setSelectedBankAccount(defaultBankAccount);
    }
  }, [bankAccountList]);

  // MARK: ---- FUNCTIONS ----
  const handleSubmit = async () => {
    setReadyToValidate(true);
    if (!Utils.isValid(selectedBankAccount)) {
      ToastHelper.showError('Vui lòng chọn tài khoản thụ hưởng');
      return;
    }
    if (!Utils.isValid(amount)) {
      ToastHelper.showError('Vui lòng nhập số tiền');
      return;
    }
    if (_.toNumber(amount) < 10000 || _.toNumber(amount) > 20000000) {
      ToastHelper.showError('Số tiền phải nằm trong khoảng 10.000đ đến 20.000.000đ');
      return;
    }
    if (_.toNumber(amount) > balance) {
      ToastHelper.showError('Số tiền rút không được lớn hơn số dư tài khoản');
      return;
    }
    const res = await AgencyHelper.API.requestAgencyWithdraw({
      amount,
      currency: "VNĐ",
      bankCode: selectedBankAccount.bankCode,
      bankAccount: selectedBankAccount?.bankAccount,
      bankName: selectedBankAccount?.bankName,
      bankBeneficiary: selectedBankAccount?.bankBeneficiary,
    })
    if (res && _.isBoolean(res)) {
      AppDialogHelper.show(
        'Gửi yêu cầu thành công',
        'Giao dịch rút tiền đang được xử lý, chúng tôi sẽ phê duyệt giao dịch này trong thời gian sớm nhất.',
        [
          {
            title: 'Tôi đã hiểu',
            type: 'neutral',
            onClick: () => {
              setAmount('');
              setReadyToValidate(false);
              AppDialogHelper.hide();
            },
          },
        ],
        false,
        AppResource.images.dialogIcons.dialogSuccess
      )
    } else {
      ToastHelper.showError(res || 'Gửi yêu cầu thất bại.')
    }
  };

  return (
    <div className="px-4 my-4">
      {UIHelper.buildCard(
        <div>
          <div className="pb-4">
            {/* header */}
            <div
              className="px-4 pt-4 pb-4 d-flex align-items-center justify-content-between"
              style={{
                borderBottom: `1px solid ${AppColors.gray[300]}`,
              }}
            >
              {/* title */}
              <div className="d-flex flex-column">
                <span style={UIHelper.buildFontStyle('600', '18px', AppColors.gray[800])}>
                  Rút tiền về tài khoản
                </span>
              </div>
            </div>
            {/* body */}
            <div className="pt-4">
              <div className="px-4">
                <span style={UIHelper.buildFontStyle('600', '16px', AppColors.gray[900])}>
                  Số dư ví:{' '}
                  <span style={UIHelper.buildFontStyle('600', '16px', AppColors.primary)}>
                    {Utils.formatNumber(balance)} VNĐ
                  </span>
                </span>
              </div>
              <div
                className="mt-2 row m-0 p-0 px-2"
                style={{
                  borderBottom: `1px dashed ${AppColors.gray[300]}`,
                }}
              >
                <div className="col-lg-4 mb-2 px-2">
                  {UIHelper.buildFormLabel('Số tiền muốn rút', true)}
                  <KTFormInput
                    type={KTFormInputType.currency}
                    placeholder="Nhập số"
                    name="amount"
                    value={amount}
                    onChange={(value) => {
                      setAmount(value);
                    }}
                    enableCheckValid={readyToValidate}
                    isValid={
                      Utils.isValid(amount) &&
                      _.toNumber(amount) >= 10000 &&
                      _.toNumber(amount) <= 20000000
                    }
                    isTouched={true}
                    feedbackText={
                      !Utils.isValid(amount)
                        ? 'Vui lòng nhập số tiền'
                        : _.toNumber(amount) < 10000 || _.toNumber(amount) > 20000000
                          ? 'Số tiền không hợp lệ'
                          : ''
                    }
                  />
                  <div className="mt-1">
                    {UIHelper.buildFormText('Tối thiểu: 10.000 ₫/ Tối đa: 20.000.000 ₫')}
                  </div>
                </div>
              </div>

              {/* tai khoan thu huong */}
              <div className="pt-4" style={{ borderBottom: `1px dashed ${AppColors.gray[300]}` }}>
                <span
                  className="px-4"
                  style={UIHelper.buildFontStyle('600', '16px', AppColors.gray[900])}
                >
                  Tài khoản thụ hưởng
                </span>
                <div className="row m-0 p-0 px-2 mt-2">
                  <div className="col-lg-4 mb-4 px-2">
                    {UIHelper.buildFormLabel('Số tài khoản', true)}
                    <KTBSDropdown
                      name="bankAccountNumber"
                      toggleElement={
                        <button
                          className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between ${readyToValidate && !Utils.isValid(selectedBankAccount)
                            ? 'button-invalid'
                            : ''
                            }`}
                          type="button"
                        >
                          {selectedBankAccount?.bankAccount ?? 'Chọn tài khoản thụ hưởng'}
                        </button>
                      }
                      selectedValue={selectedBankAccount?.bankAccountId}
                      dropdownMenuItems={bankAccountOptions}
                      dropdownMenuClassName="overflow-auto w-100"
                      dropdownMenuStyle={{ maxHeight: '30vh' }}
                      onChange={(value) => {
                        setSelectedBankAccount(
                          _.find(bankAccountList, (item) => item.bankAccountId === value)
                        );
                      }}
                      isDropdownForm={true}
                    />
                  </div>
                  <div className="col-lg-4 mb-4 px-2">
                    {UIHelper.buildFormLabel('Ngân hàng', true)}
                    <KTFormInput
                      type={KTFormInputType.text}
                      placeholder="Ngân hàng"
                      name="bankName"
                      value={
                        Utils.isValid(selectedBankAccount)
                          ? [selectedBankAccount.bankName, selectedBankAccount.bankCode].join(' - ')
                          : ''
                      }
                      disabled={true}
                    />
                  </div>
                  <div className="col-lg-4 mb-4 px-2">
                    {UIHelper.buildFormLabel('Người thụ hưởng', true)}
                    <KTFormInput
                      type={KTFormInputType.text}
                      placeholder="Người thụ hưởng"
                      name="bankAccountName"
                      value={
                        Utils.isValid(selectedBankAccount)
                          ? selectedBankAccount.bankBeneficiary
                          : ''
                      }
                      disabled={true}
                    />
                  </div>
                </div>
              </div>

              {/* actions */}
              <div className="d-flex align-items-center px-4 mt-4">
                {UIHelper.buildGreenButton('Xác nhận rút tiền', handleSubmit, null, false, loading)}
              </div>
            </div>
          </div>
        </div>,
        false
      )}
    </div>
  );
}

export default AgencyWithdrawView;
